import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { siteConfig } from "@/lib/data";

export default function TermsOfServicePage() {
  return (
    <>
      <Helmet>
        <title>Terms of Service | {siteConfig.name}</title>
        <meta name="description" content="Syarat dan Ketentuan layanan PT. Naincode Inti Technology. Ketentuan penggunaan layanan teknologi kami." />
        <link rel="canonical" href={`${siteConfig.url}/terms-of-service`} />
      </Helmet>
      
      <section className="pt-32 pb-24">
      <div className="section-container section-padding">
        <div className="max-w-3xl mx-auto">
          <Link to="/" className="inline-flex items-center gap-2 text-white/50 hover:text-neon-400 transition-colors mb-8">
            <ArrowLeft className="w-4 h-4" />
            Kembali
          </Link>

          <h1 className="text-3xl md:text-4xl font-bold gradient-text-white mb-8">
            Terms of Service
          </h1>

          <div className="prose prose-invert max-w-none">
            <p className="text-white/50 mb-6">
              Terakhir diperbarui: 14 April 2026
            </p>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">1. Penerimaan Ketentuan</h2>
            <p className="text-white/50 leading-relaxed mb-4">
              Dengan mengakses dan menggunakan website serta layanan PT. Naincode Inti Technology ("Naincode"), Anda menyetujui untuk terikat oleh syarat dan ketentuan ini.
            </p>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">2. Layanan</h2>
            <p className="text-white/50 leading-relaxed mb-4">
              Naincode menyediakan layanan pengembangan software, konsultasi teknologi, dan solusi digital lainnya. Detail layanan akan dibahas lebih lanjut dalam perjanjian terpisah.
            </p>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">3. Konsultasi Gratis</h2>
            <p className="text-white/50 leading-relaxed mb-4">
              Kami menawarkan sesi konsultasi awal gratis tanpa komitmen. Konsultasi ini bersifat informatif dan tidak mengikat kedua belah pihak untuk melakukan kerjasama lebih lanjut.
            </p>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">4. Kekayaan Intelektual</h2>
            <p className="text-white/50 leading-relaxed mb-4">
              Semua konten, kode, desain, dan materi di website ini dilindungi oleh hak cipta dan undang-undang kekayaan intelektual. Penggunaan materi tanpa persetujuan tertulis dari Naincode dilarang.
            </p>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">5. Kerahasiaan</h2>
            <p className="text-white/50 leading-relaxed mb-4">
              Kami berkomitmen untuk menjaga kerahasiaan informasi yang Anda bagikan selama proses konsultasi dan project. Informasi tidak akan dibagikan kepada pihak ketiga tanpa persetujuan Anda.
            </p>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">6. Batasan Tanggung Jawab</h2>
            <p className="text-white/50 leading-relaxed mb-4">
              Naincode tidak bertanggung jawab atas kerugian tidak langsung yang timbul dari penggunaan layanan kami. Tanggung jawab kami dibatasi sesuai dengan nilai kontrak yang disepakati.
            </p>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">7. Force Majeure</h2>
            <p className="text-white/50 leading-relaxed mb-4">
              Naincode tidak bertanggung jawab atas keterlambatan atau kegagalan dalam melaksanakan kewajiban yang disebabkan oleh keadaan di luar kendali kami, termasuk bencana alam, perang, atau pandemi.
            </p>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">8. Perubahan Ketentuan</h2>
            <p className="text-white/50 leading-relaxed mb-4">
              Naincode berhak untuk mengubah syarat dan ketentuan ini sewaktu-waktu. Perubahan akan efektif setelah dipublikasikan di website.
            </p>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">9. Hukum yang Berlaku</h2>
            <p className="text-white/50 leading-relaxed mb-4">
              Syarat dan ketentuan ini diatur oleh hukum Republik Indonesia. Setiap sengketa akan diselesaikan melalui musyawarah atau jalur hukum yang berlaku.
            </p>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">10. Kontak</h2>
            <p className="text-white/50 leading-relaxed mb-4">
              Untuk pertanyaan terkait syarat dan ketentuan ini, hubungi kami di:
            </p>
            <p className="text-white/50 leading-relaxed">
              <strong>Email:</strong> hello@naincode.com<br />
              <strong>Telepon:</strong> +62 877-8814-1650<br />
              <strong>Alamat:</strong> Jl. Tanah Abang II No.74A, Petojo Sel., Kecamatan Gambir, Kota Jakarta Pusat, DKI Jakarta 10160
            </p>
          </div>
        </div>
      </div>
    </section>
    </>
  );
}
